import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import MovieGrid from './components/MovieGrid';
import PopularRanking from './components/PopularRanking';
import PageSEO from '@/components/feature/PageSEO';
import { hotMovies, newMovies, recommendedMovies } from '@/mocks/movies';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '天天影院',
    url: 'https://tiantiancinema.com',
    description: '天天影院拥有最新电影大全、动作片在线、喜剧片免费看、科幻片高清播放及经典电影全集，极速播放不卡顿，海量片库免费高清在线看。',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://tiantiancinema.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '天天影院',
    url: 'https://tiantiancinema.com',
    description: '天天影院是最新电影大全在线观看平台，提供动作片、喜剧片、科幻片高清播放及经典电影全集免费在线看。',
    sameAs: [
      'https://weibo.com/tiantiancinema',
      'https://www.douyin.com/user/tiantiancinema',
    ],
  };

  return (
    <>
      <PageSEO
        title="天天影院 · 最新电影大全 | 动作片在线 喜剧片免费看 科幻片高清播放"
        description="天天影院拥有最新电影大全、动作片在线、喜剧片免费看、科幻片高清播放及经典电影全集，极速播放不卡顿，海量片库免费高清在线看。天天影院是您的最佳在线观影平台。"
        keywords="天天影院,最新电影大全,动作片在线,喜剧片免费看,科幻片高清播放,经典电影全集,电影大全,极速播放,免费电影"
        canonicalUrl="https://tiantiancinema.com/"
        ogTitle="天天影院 · 最新电影大全 | 动作片在线 喜剧片免费看 科幻片高清播放"
        ogDescription="天天影院拥有最新电影大全、动作片在线、喜剧片免费看、科幻片高清播放及经典电影全集，极速播放不卡顿，海量片库免费高清在线看。"
        ogUrl="https://tiantiancinema.com/"
        structuredData={[websiteSchema, organizationSchema]}
      />

      <main>
        <HeroBanner />

        <CategoryNav />

        <MovieGrid
          title="正在热播"
          subtitle="全网热门电影，不容错过"
          linkTo="/category/action"
          linkLabel="更多热播"
          movies={hotMovies}
        />

        <MovieGrid
          title="最新上映"
          subtitle="第一时间欣赏精彩大片"
          linkTo="/category/scifi"
          linkLabel="更多新片"
          movies={newMovies}
        />

        <PopularRanking />

        <MovieGrid
          title="编辑推荐"
          subtitle="精选口碑佳作，值得一看"
          movies={recommendedMovies}
          variant="featured"
        />

        <section className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-10">
          <div className="rounded-2xl bg-gradient-to-r from-primary-500/15 to-accent-500/15 border border-primary-500/20 p-8 md:p-12 text-center">
            <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-50 mb-3">
              海量片库 · 极速播放 · 免费高清
            </h3>
            <p className="text-sm md:text-base text-foreground-400 max-w-2xl mx-auto mb-6">
              天天影院拥有最新电影大全，覆盖动作片、喜剧片、科幻片、经典电影等多种类型。极速播放不卡顿，免费高清在线看，随时随地享受极致观影体验。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="/category/action"
                className="px-8 py-3 whitespace-nowrap rounded-full bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer"
              >
                开始观影
              </a>
              <a
                href="/about"
                className="px-8 py-3 whitespace-nowrap rounded-full border border-foreground-400/40 text-foreground-200 text-sm hover:border-foreground-300 transition-colors cursor-pointer"
              >
                了解更多
              </a>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}